import React, { useState, useEffect, useLayoutEffect } from "react";
import { Popover } from "antd";
import { get } from "lodash";
import { useCurrentUser } from "store/users/selectors";
import StudentHome from "containers/StudentHome";
import TeacherHome from "containers/TeacherHome";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import SentryWrap from 'components/Sentry';

const PopoverWrapper = styled.div`
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  // max-height: 50vh;
  overflow-y: auto;
  overflow-x:hidden;
  max-height: 390px;
`;

const TopDrawer = ({ children, onOpenDrawer=()=>{} }) => {
  const currentUser = useCurrentUser();
  const is_Student = get(currentUser, "role") === "student";
  const location = useLocation(); // ✅ get location object
  const [visible, setVisible] = useState(false);

  // ✅ useEffect to watch route changes (key)
  useEffect(() => {
    setVisible(false);
    onOpenDrawer();
  }, [location.key]);

  useLayoutEffect(() => {
      const handleResize = () => {
        setVisible(false);
      };
  
      window.addEventListener("resize", handleResize);
  
      return () => {
          window.removeEventListener("resize", handleResize);
      };
  }, []);

  useEffect(() => {
    if (visible) {
      // document.body.style.overflow = 'hidden';
      // disableBodyScroll('ClassDrawerComp');
    }
    return () => {
      document.body.style.overflow = '';  
    };
  }, [visible]);

  return (
    <SentryWrap>
      {/* <div className="custom-popover"> */}
        <Popover
          arrow={false}
          content={
        <PopoverWrapper>
          {is_Student ? (
            <StudentHome fromDrawer={false} setVisible={setVisible} from_menu={true} visible={visible}
            />
          ) : (
              <TeacherHome fromDrawer={true} setVisible={setVisible} from_menu={true}
              />
          )}
        </PopoverWrapper>
      }
      trigger="click"
      //placement="bottomLeft"
      overlayClassName="custom-popover"
      open={visible}
      onOpenChange={(val) => setVisible(val)}
      overlayStyle={{ position:'absolute', top:'100px', left:'0px'}}
    >
          {children}
      </Popover>
      {/* </div> */}
    </SentryWrap>
  );
};

export default TopDrawer;